export default [
  {
    title: 'Miss You, 2019',
    format: '66 x 51 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '155 exemplaires'
  },

  {
    title: 'SAMO, 2018',
    format: 'Format 160 x 113 cm',
    colors: '10 couleurs',
    paper: 'Arches 300 grs',
    tirage: '47 exemplaires'
  },

  {
    title: 'Ghosts, 2018',
    format: 'Format 78 x 57 cm',
    colors: '5 couleurs',
    paper: 'Arches 300 grs',
    tirage: '71 exemplaires'
  },

  {
    title: 'Art News, 2018',
    format: 'Format 116,5 x 76 cm',
    colors: '18 couleurs',
    paper: 'Arches 400 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Coffee Shop, 2017',
    format: 'Format 65 x 46 cm',
    colors: '4 couleurs',
    paper: 'Arches 300 grs',
    tirage: '285 exemplaires'
  },

  {
    title: 'Crime Scene, 2015',
    format: 'Format 39 x 30 cm',
    colors: '4 couleurs',
    paper: 'Arches 400 grs',
    tirage: '114 exemplaires'
  },

  {
    title: 'Happy Hours, 2015',
    format: 'Format 51 x 65 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Pink Cadillac, 2015',
    format: 'Format 75,5 x 62 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'A New World, 2014',
    format: 'Format 76,5 x 109 cm',
    colors: '23 couleurs',
    paper: 'Arches 400 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Red Fish, 2014',
    format: 'Format 104 x 77 cm',
    colors: '22 couleurs',
    paper: 'Arches 400 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Super Boys, 2013',
    format: 'Format 77 x 115 cm',
    colors: '20 couleurs',
    paper: 'Arches 400 grs',
    tirage: '340 exemplaires'
  },

  {
    title: 'You are not…, 2012',
    format: 'Format 98,5 x 78 cm',
    colors: '22 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'New York Post, 2012',
    format: 'Format 65 x 50 cm',
    colors: '9 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Gâteaux!, 2011',
    format: 'Format 65 x 50 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Speedy, 2011',
    format: 'Format 65 x 50 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Homage to Basquiat, 2011',
    format: 'Format 74 x 56 cm',
    colors: '11 couleurs',
    paper: 'Arches 300 grs',
    tirage: '175 exemplaires'
  },

  {
    title: 'Meeting, 2010',
    format: 'Format 81 x 61 cm',
    colors: '18 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Love Story, 2010',
    format: 'Format 77 x 115 cm',
    colors: '20 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'I Have a Dream, 2010',
    format: 'Format 77 x 116 cm',
    colors: '24 couleurs',
    paper: 'Arches 400 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Alice dans le métro, 2009',
    format: 'Format 99 x 70 cm',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Ornano 43, 2009',
    format: 'Format 61 x 75 cm',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Midtown Comics, 2009',
    format: 'Format 78 x 94 cm',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Downtown, 2008',
    format: 'Format 77 x 115 cm',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Policierotic, 2007',
    format: 'Format 77 x 115 cm',
    colors: '22 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'On the Road, 2006',
    format: 'Format 52 x 74 cm',
    colors: '8 couleurs',
    paper: 'Arches 300 grs',
    tirage: '300 exemplaires'
  },

  {
    title: 'The show must go on, 2006',
    format: 'Format 97 x 77 cm',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '350 exemplaires'
  },

  {
    title: 'Dream cars, 2005',
    format: 'Format 52 x 74 cm',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '300 exemplaires'
  },

  {
    title: 'The comics section, 2004',
    format: 'Format 99 x 78 cm',
    colors: '21 couleurs',
    paper: 'Arches 300 grs',
    tirage: '300 exemplaires'
  },

  {
    title: 'Fin de siècle, 2003',
    format: 'Format 78 x 109 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '300 exemplaires'
  },

  {
    title: 'Boulevard Lautrec, 2002',
    format: 'Format 66 x 51 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '300 exemplaires'
  },

  {
    title: 'Adieu Marilyn, 2002',
    format: 'Format 67 x 86 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '300 exemplaires'
  },

  {
    title: 'Open 24 Hours, 2001',
    format: 'Format 112 x 77 cm',
    colors: '20 couleurs',
    paper: 'Arches 300 grs',
    tirage: '300 exemplaires'
  },

  {
    title: 'Manhattan Colors, 2001',
    format: 'Format 77 x 110 cm',
    colors: '20 couleurs',
    paper: 'Arches 300 grs',
    tirage: '300 exemplaires'
  },

  {
    title: 'Porsches 911, 2000',
    format: 'Format 79 x 115 cm',
    colors: '18 couleurs',
    paper: 'Arches 300 grs',
    tirage: '911 exemplaires et 75 épreuves d’artiste'
  },

  {
    title: 'Hommage à Picasso, 2000',
    format: 'Format 50 x 65 cm',
    colors: '6 couleurs',
    paper: 'Arches 300 grs',
    tirage: '70 exemplaires'
  },

  {
    title: 'Eden, 2000',
    format: 'Format 60 x 80 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '285 exemplaires'
  },

  {
    title: 'Manhattan I, 1999',
    format: 'Format 75,5 x 62 cm',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '325 exemplaires'
  },

  {
    title: 'Manhattan II, 1999',
    format: 'Format 76,5 x 109 cm',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '325 exemplaires'
  },

  {
    title: 'New Wave, 1999',
    format: 'Format 65 x 50 cm',
    colors: '8 couleurs',
    paper: 'Arches 300 grs',
    tirage: '300 exemplaires'
  },

  {
    title: 'Cinéma cinéma, 1998',
    format: 'Format 102 x 73 cm',
    colors: '9 couleurs',
    paper: 'Arches 300 grs',
    tirage: '3691 exemplaires'
  },

  {
    title: 'Sunset, 1998',
    format: 'Format  65 x 50 cm',
    colors: '8 couleurs',
    paper: 'Arches 300 grs',
    tirage: '223 exemplaires'
  },

  {
    title: 'American Psycho, 1998',
    format: 'Format 113 x 145 cm (triptyque)',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '325 exemplaires'
  },

  {
    title: 'Movie Street, 1997',
    format: 'Format 71 x 98 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '323 exemplaires'
  },

  {
    title: 'German Garage II, 1997',
    format: 'Format 74 x 56 cm',
    colors: '20 couleurs',
    paper: 'Arches 300 grs',
    tirage: '323 exemplaires'
  },

  {
    title: 'Rallye Sixties, 1996',
    format: 'Format 63 x 76 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '313 exemplaires'
  },

  {
    title: 'Around the Corner, 1996',
    format: 'Format 90 x 61 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '287 exemplaires'
  },

  {
    title: 'Tommy, 1995',
    format: 'Format 63 x 90 cm',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '285 exemplaires'
  },

  {
    title: 'Breakfast in America, 1995',
    format: 'Format 99 x 70 cm (triptyque)',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '275 exemplaires'
  },

  {
    title: 'Scooter, 1995',
    format: 'Format 94 x 135 cm',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '285 exemplaires'
  },

  {
    title: 'Shadows, 1994',
    format: 'Format 63 x 82,5 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '285 exemplaires'
  },

  {
    title: 'Drive in, 1994',
    format: 'Format 80 x 116 cm',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '285 exemplaires'
  },

  {
    title: 'Garage Français, 1994',
    format: 'Format 60 x 78 cm',
    colors: '18 couleurs',
    paper: 'Arches 300 grs',
    tirage: '285 exemplaires'
  },

  {
    title: 'London Film, 1993',
    format: 'Format 70 x 100 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '235 exemplaires'
  },

  {
    title: 'Sixties, 1993',
    format: 'Format 60 x 78 cm',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Route 66, 1993',
    format: 'Format 73 x 89 cm',
    colors: '18 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'German Garage, 1993',
    format: 'Format 60 x 78 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Private Investigation, 1992',
    format: 'Format 63 x 80 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'American Dream, 1992',
    format: 'Format 60 x 78 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Jimi’s dead, 1992',
    format: 'Format 75 x 88 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Italia, 1992',
    format: 'Format 60 x 78 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'English Garage, 1991',
    format: 'Format 60 x 78 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Time Square, 1991',
    format: 'Format 74,5 x 88 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Bumper Cars, 1991',
    format: 'Format 775 x 88 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Requiem, 1990',
    format: 'Format 75 x 88 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '210 exemplaires'
  },

  {
    title: 'Thriller, 1990',
    format: 'Format 74 x 88 cm',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'East of Eden, 1990',
    format: 'Format 74 x 88 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '210 exemplaires'
  },

  {
    title: 'On Abbey Road, 1989',
    format: 'Format 75 x 88 cm',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'La maison vide, 1989',
    format: 'Format 70 x 87 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Marlène, 1989',
    format: 'Format 72 x 89 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Piano, 1989',
    format: 'Format 99 x 79 cm',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'La fille de la 42nd rue, 1989',
    format: 'Format 113 x 145 cm (triptyque)',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Duo, 1989',
    format: 'Format 72 x 89 cm',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '210 exemplaires'
  },

  {
    title: 'Bus Stop, 1989',
    format: 'Format 74 x 88 cm',
    colors: '17 couleurs',
    paper: 'Arches 300 grs',
    tirage: '210 exemplaires'
  },

  {
    title: 'Toupie, 1988',
    format: 'Format 68 x 88 cm',
    colors: '18 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'To paint or not to paint, 1988',
    format: 'Format 92 x 80 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Detective, 1988',
    format: 'Format 60 x 85 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Bien arrivés à la mer, 1988',
    format: 'Format 71 x 87 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Omaha Beach 1950, 1988',
    format: 'Format 79 x 113 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '233 exemplaires'
  },

  {
    title: 'Teddy Bear, 1988',
    format: 'Format 80 x 120 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '223 exemplaires'
  },

  {
    title: 'Le privé et la Mustang, 1987',
    format: 'Format 74 x 88 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '237 exemplaires'
  },

  {
    title: 'Stravinsky à New-York, 1987',
    format: 'Format 68 x 88 cm (dyptique)',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '235 exemplaires'
  },

  {
    title: 'Canal Street, 1987',
    format: 'Format 107 x 78 cm',
    colors: '16 couleurs',
    paper: 'Arches 300 grs',
    tirage: '232 exemplaires'
  },

  {
    title: 'Thunderbird, 1987',
    format: 'Format 72 x 89 cm',
    colors: '18 couleurs',
    paper: 'Arches 300 grs',
    tirage: '228 exemplaires'
  },

  {
    title: 'Chevaux de la plage, 1987',
    format: 'Format 107 x 78 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '232 exemplaires'
  },

  {
    title: 'La Mercedes du Casino, 1986',
    format: 'Format 74 x 88 cm',
    colors: '15 couleurs',
    paper: 'Arches 300 grs',
    tirage: '243 exemplaires'
  },

  {
    title: 'Dolce Vita, 1986',
    format: 'Format 74 x 88 cm',
    colors: '15 couleurs',
    paper: 'Arches 270 grs',
    tirage: '243 exemplaires'
  },

  {
    title: 'Taxi on Broadway, 1986',
    format: 'Format 118 x 161 cm',
    colors: '19 couleurs',
    paper: 'Arches 300 grs',
    tirage: '125 exemplaires'
  },

  {
    title: 'Une Cadillac pour Marilyn, 1985',
    format: 'Format 70 x 100 cm',
    colors: '20 couleurs',
    paper: 'Arches 270 grs',
    tirage: '175 exemplaires'
  },

  {
    title: 'La Jag, 1985',
    format: 'Format 70 x 100 cm',
    colors: '18 couleurs',
    paper: 'Arches 270 grs',
    tirage: '175 exemplaires'
  },

  {
    title: 'Bar de l’aviation, 1985',
    format: 'Format 59 x 80 cm',
    colors: '15 couleurs',
    paper: 'Arches 270 grs',
    tirage: '200 exemplaires'
  },

  {
    title: 'Broadway, 1984',
    format: 'Format 107 x 78 cm',
    colors: '18 couleurs',
    paper: 'Arches 270 grs',
    tirage: '175 exemplaires'
  },

  {
    title: 'Imagine, 1982',
    format: 'Format 61 x 77 cm',
    colors: '12 couleurs',
    paper: 'Arches 270 grs',
    tirage: '214 exemplaires'
  },

  {
    title: 'Cirque Pepito, 1981',
    format: 'Format 75 x 55 cm',
    colors: '19 couleurs',
    paper: 'Arches 270 grs',
    tirage: '212 exemplaires'
  },

  {
    title: 'Tout va bien, 1981',
    format: 'Format 75 x 54,5 cm',
    colors: '14 couleurs',
    paper: 'Arches 270 grs',
    tirage: '212 exemplaires'
  },

  {
    title: 'Le manège de l’avenir, 1979',
    format: 'Format 75,5 x 54,5 cm',
    colors: '12 couleurs',
    paper: 'Arches 270 grs',
    tirage: '175 exemplaires'
  }
];
